"use strict";

var getDigestFragmentsForCutsites = require("./getDigestFragmentsForCutsites");
var cutSequenceByRestrictionEnzyme = require("./cutSequenceByRestrictionEnzyme");

var _require = require("lodash"),
    flatMap = _require.flatMap;

module.exports = function getDigestFragmentsForRestrictionEnzymes(sequence, circular, restrictionEnzymeOrEnzymes, opts) {
  var restrictionEnzymes = Array.isArray(restrictionEnzymeOrEnzymes) ? restrictionEnzymeOrEnzymes : [restrictionEnzymeOrEnzymes];
  var cutsites = flatMap(restrictionEnzymes, function (restrictionEnzyme) {
    return cutSequenceByRestrictionEnzyme(sequence, circular, restrictionEnzyme);
  });
  return getDigestFragmentsForCutsites(sequence.length, circular, cutsites, opts);
};